<template>
  <div>
    <div class="d-flex flex-column">
      <v-row class="d-flex justify-center" style="max-height: 48px" :style="{ backgroundColor: themeColor.highlightBackgroundColor }">
        <v-col cols="12" sm="6" md="4" class="py-0 pa-0 ma-0" :style="styleObject1">
			<v-icon color="white" style="position: absolute; right: 5px; top: 5px; z-index: 1" large @click="closeDialog">mdi-close-circle-outline</v-icon>
			<v-text-field
				height="100%"
				class="search-bar"
				:background-color="themeColor.searchBarColor"
				:color="themeColor.fontColor"
				solo
				flat
				placeholder="Search Attendees and Exhibitors"
				prepend-inner-icon="mdi-magnify"
				single-line
				hide-details
				v-model="keyword"
				v-on:keyup.enter="search()"
			></v-text-field>
        </v-col>
      </v-row>
      <v-row class="d-md-inline-flex" :style="{ backgroundColor: themeColor.backgroundColor, minHeight: '100vh' }">
        <v-flex xs12 md4 :style="{ backgroundColor: themeColor.highlightBackgroundColor }">
          <v-toolbar :color="themeColor.highlightBackgroundColor" flat>
            <v-btn color="white" outlined depressed rounded @click="showMyAppointments" class="ma-2">
              <b>My Appointment</b>
            </v-btn>
          </v-toolbar>
          <v-toolbar :color="themeColor.highlightBackgroundColor" flat>
            <h4 :style="{ color: themeColor.fontColor}" class="ma-2">Match with similar interests</h4>
            <v-spacer />
            <v-btn
              @click="
                selectedInterest = [];
                search();
              "
              :color="themeColor.buttonBackgroundColor3"
              small
              outlined
              depressed
              rounded
              ><b>Reset</b></v-btn
            >
          </v-toolbar>
          <div :style="{ overflow: 'auto', backgroundColor: themeColor.highlightBackgroundColor, marginLeft: '25px' }">
            <v-chip-group @change="search()" v-model="selectedInterest" column multiple>
              <v-chip
                v-for="item in interestList"
                :key="item.id"
                :value="item.id"
                :text-color="selectedInterest.includes(item.id) ? themeColor.fontColor : myInterest.includes(item.id) ? themeColor.fontColor : themeColor.buttonBackgroundColor2"
                :color="selectedInterest.includes(item.id) ? themeColor.buttonBackgroundColor : myInterest.includes(item.id) ? themeColor.buttonBackgroundColor2 : themeColor.searchBarColor"
                ><b>{{ item.name }}</b></v-chip
              >
            </v-chip-group>
          </div>
        </v-flex>

        <v-flex xs12 md8 height="100%">
          <v-tabs v-model="tab" :background-color="themeColor.backgroundColor" :color="themeColor.fontColor" flat fixed-tabs>
            <v-tab v-for="item in profileTabs" :key="item"
              ><h4 :style="{ color: themeColor.fontColor }">{{ item }}</h4>
              &nbsp; &nbsp;
              <h5 :style="{ color: themeColor.fontColor }">{{ item == profileTabs[0] ? attendeePage.total : exhibitorPage.total }} matches</h5></v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tab" :style="{ backgroundColor: themeColor.backgroundColor }">
            <!-- Attendees -->
            <v-tab-item style="padding-left: 5px">
              <v-card v-for="(item, index) in attendeePage.data" :key="index" :color="themeColor.additionalBackgroundColor" class="d-flex" dark width="96.5%" height="130px" style="margin: 10px; padding: 5px; overflow: hidden" flat>
                <div style="padding-left: 20px; padding-right: 10px">
                  <v-avatar color="white" size="110">
                    <v-img sizes="110" v-if="item.image" :src="baseLocation + '/asset/file/user/' + item.image"></v-img>
                    <v-icon color="grey darken-2" v-else size="110">mdi-account-circle</v-icon>
                  </v-avatar>
                </div>
                <div class="d-flex flex-column" style="width: 100%">
                  <v-card-text :style="{ color: themeColor.fontColor, overflow: 'hidden', padding: '10px' }">
                    <h3 :style="{ padding: 0, margin: 0, maxHeight: '20px', overflow: 'hidden' }">
                      {{ item.firstName + " " + item.lastName + " - " }} {{ item.title ? item.title : " " }} {{ item.title && item.company ? ", " : "" }} {{ item.company ? item.company : " " }}
                    </h3>
                    <div :style="{ color: themeColor.fontColor, maxHeight: '20px', overflow: 'hidden' }"><b>Availability : </b> {{item.availability ? item.availability : ""}}</div>
                    <div :style="{ color: themeColor.fontColor, maxHeight: '20px', overflow: 'hidden' }"><b>interests</b> - {{ item.interestNameData ? item.interestNameData.replaceAll("\n, ", ", ") : "" }}</div>
                    <v-flex>
                      <v-btn :color="themeColor.buttonBackgroundColor3" :style="{ float: buttonFloat ? 'right' : 'none' }" class="ma-2" @click="showProfileDialog(item)" small outlined rounded>Profile</v-btn>
                      <v-btn :color="themeColor.buttonBackgroundColor3" :style="{ float: buttonFloat ? 'right' : 'none' }" icon large v-if="item.businessCardFrontImg || item.businessCardBackImg" @click="showBusinessCardDialog(item)">
                        <v-icon large>mdi-card-account-details-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-card-text>
                </div>
              </v-card>
              <v-row class="d-flex justify-end align-center" align="end" style="padding-right: 40px">
                <v-select style="max-width: 75px" @change="listAttendee()" v-model="attendeePage.size" :items="itemsPerPageOptions" solo dark></v-select>
                <v-pagination :color="themeColor.buttonBackgroundColor" style="margin-bottom: 32px" @input="listAttendee()" v-model="attendeePage.page" :length="attendeePage.length" total-visible="15" dark></v-pagination>
              </v-row>
            </v-tab-item>

            <!-- Exhibitors -->
            <v-tab-item style="padding-left: 5px">
              <v-card v-for="(item, index) in exhibitorPage.data" :key="index" :color="themeColor.additionalBackgroundColor" class="d-inline-flex" dark width="96.5%" height="130px" style="margin: 10px; padding: 5px" flat>
                <div style="padding-left: 30px; padding-right: 10px">
                  <v-avatar color="white" size="110">
                    <v-img sizes="110" v-if="item.logo && (item.logo.startsWith('http://') || item.logo.startsWith('https://'))" :src="item.logo"></v-img>
                    <v-img sizes="110" v-else-if="item.logo" :src="baseLocation + '/asset/file/user/' + item.logo"></v-img>
                    <v-icon color="grey darken-2" v-else size="110">mdi-account-circle</v-icon>
                  </v-avatar>
                </div>
                <v-card-text :style="{ color: themeColor.fontColor, overflow: 'hidden' }">
                  <h3 :style="{ padding: 0, margin: 0, maxHeight: '20px', overflow: 'hidden' }">{{ item.name }}</h3>
                  <div v-html="item.description" :style="{ overflow: 'hidden', height: '20px', fontSizeAdjust: 0.05, color: themeColor.fontColor }"></div>
                  <div :style="{ color: themeColor.fontColor, maxHeight: '20px', overflow: 'hidden' }"><b>interests</b> - {{ item.interestNameData ? item.interestNameData.replaceAll("\n, ", ", ") : "" }}</div>
                  <v-flex>
                    <v-btn :style="{ float: buttonFloat ? 'right' : 'none' }" class="ma-2" @click="exhibit(item)" :color="themeColor.buttonBackgroundColor3" small outlined rounded depressed>Exhibit</v-btn>
                  </v-flex>
                </v-card-text>
              </v-card>
              <v-row class="d-flex justify-end align-center" align="end" style="padding-right: 40px">
                <v-select style="max-width: 75px" @change="listExhibitor()" v-model="exhibitorPage.size" :items="itemsPerPageOptions" solo dark></v-select>
                <v-pagination :color="themeColor.buttonBackgroundColor" style="margin-bottom: 32px" @input="listExhibitor()" v-model="exhibitorPage.page" :length="exhibitorPage.length" total-visible="15" dark></v-pagination>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-row>
    </div>
	<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
		<v-col cols="12" sm="12">
			<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
                <p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
            </div>
            <div id="v-footer" style="height: 50px; background-color: black" v-else>
                <p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
            </div>
		</v-col>
	</v-row>

    <!-- Business Card -->
    <v-dialog v-model="dialogBusinessCard.show" content-class="col-sm-8 col-12 hide-box-shadow" max-width="1024px">
      <v-card rounded="xl" :color="themeColor.highlightBackgroundColor" style="padding: 40px; overflow: auto">
        <v-card-actions style="color: white; padding: 10px">
          <v-spacer />
          <v-btn @click="saveBusinessCard(dialogBusinessCard.id)" :color="themeColor.buttonBackgroundColor3" outlined depressed rounded>Save Business Card</v-btn>
          <v-btn icon :color="themeColor.buttonBackgroundColor3" outlined @click="closeBusinessCardDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-carousel>
            <v-carousel-item v-for="(item, i) in dialogBusinessCard.data" :key="i" reverse-transition="fade-transition" transition="fade-transition">
              <v-img :src="baseLocation + '/asset/file/businesscard/' + item" contain max-height="500px"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Profile -->
    <v-dialog v-model="dialogProfile.show" content-class="col-sm-8 col-12 hide-box-shadow" max-width="1024px">
      <v-card min-height="70vh" rounded="xl" :color="themeColor.highlightBackgroundColor" style="padding: 40px; overflow: auto">
        <v-card-actions style="color: white; padding: 10px">
          <v-spacer />
          <v-btn @click="saveBusinessCard(dialogProfile.data.id)" :color="themeColor.buttonBackgroundColor3" outlined depressed rounded :disabled="!dialogProfile.data.businessCardFrontImg && !dialogProfile.data.businessCardBackImg"
            >Save Business Card</v-btn
          >
          <v-btn icon :color="themeColor.buttonBackgroundColor3" outlined @click="closeProfileDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-title class="d-inline-flex">
          <v-avatar color="white" size="180" style="margin-right: 20px">
            <v-img sizes="180" v-if="dialogProfile.data.image && dialogProfile.data.image.startsWith('data')" :src="dialogProfile.data.image"></v-img>
            <v-img sizes="180" v-else-if="dialogProfile.data.image" :src="baseLocation + '/asset/file/user/' + dialogProfile.data.image"></v-img>
            <v-icon color="grey darken-2" v-else size="180">mdi-account-circle</v-icon>
          </v-avatar>
          <div class="d-flex flex-column" :style="{ color: themeColor.fontColor }">
            <h2>{{ dialogProfile.data.firstName + " " + dialogProfile.data.lastName }}</h2>
            <h4>{{ dialogProfile.data.title }} - {{ dialogProfile.data.company ? dialogProfile.data.company : "" }}</h4>
            <h5>Availability : {{ dialogProfile.data.availability ? dialogProfile.data.availability : "" }}</h5>
          </div>
        </v-card-title>
        <v-card-text :style="{ color: themeColor.fontColor }">
          <p>{{ dialogProfile.data.bio }}</p>
        </v-card-text>
        <v-card-text>
          <div style="max-height: 240px; overflow: auto">
            <v-chip style="margin: 2px" v-for="item in dialogProfile.data.interestNameList" :key="item" :value="item"
              ><b>{{ item }}</b></v-chip
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- My Appointemnt -->
    <v-dialog v-model="dataMyAppointmentDialog.showDialog" content-class="col-sm-8 col-12 hide-box-shadow" style="float: top">
      <template>
        <my-appointment :extData="dataMyAppointmentDialog" :experience="experience" :networkingLounge="networkingLounge" ref="myAppointment"></my-appointment>
      </template>
    </v-dialog>

    <v-snackbar v-model="snackbar.show">
      {{ snackbar.content }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style>
.search-bar > div > div > div > input {
  color: var(--input-color) !important;
}
.search-bar > div > div > div > input::placeholder {
  color: var(--input-color) !important;
}
.search-bar > div > div > div > div > i {
  color: var(--input-color) !important;
}
</style>

<script>
import axios from "axios";
import appointment from "./appointment.vue";

export default {
  props: ["tenantSlug", "experienceSlug", "extData", "networkingLounge"],
  components: {
    "my-appointment": appointment
  },
  data() {
    return {
      baseLocation: axios.defaults.baseURL,
      keyword: "",
      selectedTab: "Attendees",
      tab: "Attendees",
      profileTabs: ["Attendees", "Exhibitors"],
      myInterest: [],
      selectedInterest: [],
      itemsPerPageOptions: [5, 10, 20, 50],
      attendeePage: {
        data: [],
        page: 1,
        size: 10,
        length: 1,
        total: 0
      },
      exhibitorPage: {
        data: [],
        page: 1,
        size: 10,
        length: 1,
        total: 0
      },
      themeColor: {
        backgroundColor: "#416D74FF",
        highlightBackgroundColor: "#1E1E1EFF",
        additionalBackgroundColor: "#214D54FF",
        fontColor: "#FFFFFFFF",
        buttonBackgroundColor: "#EB7226FF",
        buttonBackgroundColor2: "#00838FFF",
        buttonBackgroundColor3: "#FFFFFFFF",
        searchBarColor: "#000000DE"
      },
      themeColorDefault: {
        backgroundColor: "#416D74FF",
        highlightBackgroundColor: "#1E1E1EFF",
        additionalBackgroundColor: "#214D54FF",
        fontColor: "#FFFFFFFF",
        buttonBackgroundColor: "#EB7226FF",
        buttonBackgroundColor2: "#00838FFF",
        buttonBackgroundColor3: "#FFFFFFFF",
        searchBarColor: "#000000DE"
      },
      dialogBusinessCard: {
        show: false,
        id: null,
        data: []
      },
      dialogProfile: {
        show: false,
        data: {}
      },
      snackbar: {
        show: false,
        content: ""
      },
      buttonFloat: true,
      interestList: [],
      dataMyAppointmentDialog: {
        showDialog: false,
        tenantSlug: this.tenantSlug,
        experienceSlug: this.experienceSlug,
		isFristLoad: true
      },
      experience: {},
      isSearch: false,
    };
  },
  computed: {
    styleObject1() {
      return {
        "--input-color": this.themeColor.fontColor
      };
    }
  },
  created() {
    window.addEventListener("resize", this.handleSmallScreenResize);
    this.handleSmallScreenResize();
  },
  mounted() {
    this.findThemeColor();
    this.listMyInterest();
    this.listInterest();
    this.listAttendee();
    this.listExhibitor();
    this.getExperience();
	this.extData.isFristLoad = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.handleSmallScreenResize);
  },
  methods: {
    findThemeColor() {
      axios
        .post("/system/experienceColors/find", {
          tenantSlug: this.tenantSlug,
          experienceSlug: this.experienceSlug,
          page: "Networking_Lounge"
        })
        .then((response) => {
          if (response.data) {
            this.themeColor = response.data;
          } else {
            this.themeColor = this.themeColorDefault;
          }
        })
        .catch(() => {});
    },
    listMyInterest() {
      axios
        .get("/system/interest/id/user/find")
        .then((response) => {
          this.myInterest = response.data;
        })
        .catch(() => {});
    },
    listInterest() {
      axios
        .get("/system/interest/experience/list")
        .then((response) => {
          this.interestList = response.data;
        })
        .catch(() => {});
    },
    getExperience() {
      axios
        .get("/system/experience/find")
        .then((response) => {
          this.experience = response.data;
          this.getTotalDocument();
        })
        .catch(() => {});
    },
    search() {
      this.isSearch = true;
      this.listExhibitor();
      this.listAttendee();
      this.isSearch = false;
    },
    listAttendee() {
      let page = this.isSearch ? 1 : this.attendeePage.page;
      axios
        .post("/system/user/lounge/attendee/list", {
          keyword: this.keyword,
          interestList: this.selectedInterest,
          page: page,
          size: this.attendeePage.size
        })
        .then((response) => {
          this.attendeePage = response.data;
        })
        .catch(() => {});
    },
    listExhibitor() {
      let page = this.isSearch ? 1 : this.exhibitorPage.page;
      axios
        .post("/system/booth/lounge/list", {
          keyword: this.keyword,
          interestList: this.selectedInterest,
          page: page,
          size: this.exhibitorPage.size
        })
        .then((response) => {
          this.exhibitorPage = response.data;
        })
        .catch(() => {});
    },
    showBusinessCardDialog(item) {
      // clear in case user did not close it first
      this.dialogBusinessCard.id = null;
      this.dialogBusinessCard.data = [];

      this.dialogBusinessCard.id = item.id;

      if (item.businessCardFrontImg) {
        this.dialogBusinessCard.data.push(item.businessCardFrontImg);
      }
      if (item.businessCardBackImg) {
        this.dialogBusinessCard.data.push(item.businessCardBackImg);
      }

      this.dialogBusinessCard.show = true;
    },
    closeBusinessCardDialog() {
      this.dialogBusinessCard.id = null;
      this.dialogBusinessCard.data = [];
      this.dialogBusinessCard.show = false;
    },
    showProfileDialog(item) {
      if (item.interestNameData) {
        item.interestNameList = item.interestNameData.split("\n, ");
      }
      this.dialogProfile.data = item;
      this.dialogProfile.show = true;
    },
    closeProfileDialog() {
      this.dialogProfile.data = {};
      this.dialogProfile.show = false;
    },
    saveBusinessCard(id) {
      axios
        .post("/system/document/businesscard/add", {
          experienceUserId: id
        })
        .then((response) => {
          this.snackbar.content = response.data;
          this.snackbar.show = true;
        })
        .catch(() => {});
    },
    exhibit(item) {
		this.closeDialog();
      this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug + "/booth/" + item.id);
    },
    handleSmallScreenResize() {
      if (window.innerWidth <= 600) {
        this.buttonFloat = false;
      } else {
        this.buttonFloat = true;
      }
    },
    showMyAppointments() {
      this.dataMyAppointmentDialog.showDialog = true;
      if(!this.dataMyAppointmentDialog.isFristLoad) {
		this.$refs.myAppointment.listAppointment();
		}
    },
	closeDialog() {
		this.extData.showDialog = false;
		this.$store.commit("setShowNetworkingLounge", false);
	}
  }
};
</script>